import ButtonLink from '@/components/links/ButtonLink';
import useLocale from 'next-translate/useTranslation';
import Image from 'next/image';

export default function Certifications({ reverse = false }: { reverse?: boolean }) {
  const { t } = useLocale('home');

  return (
    <div className='bg-white py-24 dark:bg-slate-900 sm:py-32'>
      <div className='mx-auto max-w-7xl px-6 lg:px-8'>
        <div className='grid grid-cols-1 items-center gap-x-8 gap-y-8 lg:grid-cols-2 lg:gap-x-16'>
          <div className={`mx-auto w-full max-w-xl lg:mx-0 ${reverse ? 'lg:order-2' : ''}`}>
            <h2 className='text-3xl font-bold tracking-tight text-gray-900 dark:text-white'>
             Dmytro OLEFYRENKO<br />
              <span className='text-2xl text-gray-600 dark:text-gray-400'>
                CTO | Founder
              </span>
            </h2>
            <h2 className='mt-6 text-xl font-bold tracking-tight text-gray-900 dark:text-white'>
            Agentic AI Architect, Agile Practitioner, Google Developer Group Member from 2018
            </h2>
            <p className='mt-6 text-lg leading-8 text-gray-600 dark:text-gray-300'>
            16+ years of experience in software engineering (Serverless, AWS, JavaScript/TypeScript, UX, AI) Dmytro is a seasoned technology leader with deep expertise in building scalable, cloud-native platforms. He has led cross-functional engineering teams of 15+ and delivered high-availability systems using serverless architectures (AWS Lambda, API Gateway, DynamoDB, S3) and modern JavaScript stacks (Node.js, React, TypeScript). 

            </p>
            <h2 className='mt-6 text-xl font-bold tracking-tight text-gray-900 dark:text-white'>
        
            His focus: reliability, security, and measurable business outcomes.
            </h2>
            <p className='mt-6 text-lg leading-8 text-gray-600 dark:text-gray-300'>
            Dmytro drives the end-to-end technology strategy for agentic AI capabilities—connecting tools, data, and workflows so teams can automate tasks and get real work done. He is hands-on with LLM integration, retrieval pipelines, and secure SaaS infrastructure, ensuring the platform remains fast, compliant, and easy to use.
            </p>
            
            <h2 className='mt-6 text-xl font-bold tracking-tight text-gray-900 dark:text-white'>
            Community and Leadership
            </h2>
            <p className='mt-6 text-lg leading-8 text-gray-600 dark:text-gray-300'>
            Dmytro actively contributes to the developer community through workshops, panels, and writing, sharing practical insights on AI adoption, cloud/serverless patterns, and engineering leadership.
            </p>
            
          </div>
          <div className={`flex h-full w-full items-center justify-center ${reverse ? 'lg:order-1' : ''}`}>
            <div className="flex h-full w-full flex-col items-center justify-center gap-10">
            <div className="flex flex-col gap-10 w-full lg:flex-row">
              <Image
                className="w-full h-[32rem] object-contain lg:w-1/2"
                src="/images/about-us/AWS_Dmytro_1.png"
                alt="ALCP Certification"
                width={1200}
                height={512}
                priority
              />
              <Image
                className="w-full h-[32rem] object-contain lg:w-1/2"
                src="/images/about-us/AWS_Dmytro3.png"
                alt="ISCA"
                width={1200}
                height={512}
                priority
              />
            </div>

              <Image
                className="w-full h-[32rem] object-contain"
                src="/images/about-us/Google_Dmytro_frame.png"
                alt="NTU AI"
                width={1200}
                height={512}
                priority
              /> 
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
